import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import * as constants from '../../config/constant/constants'
import { localization } from '../../config/localize/localizable'

const SideBarMenuItem = ({ currentMenu, items }) => {
    const location = useLocation()
    const navigate = useNavigate()
    const [selectedpPId, setSelectedpPId] = useState(-1)

    const handleClick = (menu) => {
        if (menu.parentId > 0) {
            setSelectedpPId(menu.parentId)
            constants.setLastMenuClicked(menu)
            navigate(menu.link)
        }
    }

    const handleParentClick = () => {
        if (currentMenu.id === selectedpPId) setSelectedpPId(-1)
        else setSelectedpPId(currentMenu.id)
    }

    useEffect(() => {
        if (constants.getLastMenuClicked()?.id > 0) {
            setSelectedpPId(constants.getLastMenuClicked().parentId)
        }
    }, [])

    return (
        <>
            <div className={`p-1 pr-4  cursor-pointer`} tag={currentMenu.title}>
                <div className={`h-9 p-2 mb-1 ${selectedpPId === currentMenu.id ? ' font-bold ' : ''}`} onClick={() => handleParentClick()}>
                    <img src={require('../../assets/icons/' + currentMenu.icon.split('/').pop())} className="invert w-5 inline-block ml-2" alt={currentMenu.caption} />
                    <span>{localization[currentMenu.caption.toLowerCase()]}</span>
                </div>
                {items
                    .filter((x) => x.parentId === currentMenu.id && x.visible)
                    .sort(function (a, b) {
                        return a.priority - b.priority
                    })
                    .map((subMenu, ind) => {
                        return (
                            <div key={ind}>
                                <div
                                    className={`p-1 pr-6 h-9 hover:bg-blue-100 ${location.pathname.includes(subMenu.title) ? 'text-special1  bg-whitee' : 'bg-white'} cursor-pointer ${
                                        selectedpPId === subMenu.parentId ? '' : 'hidden'
                                    }`}
                                    tag={subMenu.title}
                                    onClick={() => handleClick(subMenu)}
                                >
                                    <img src={require('../../assets/icons/' + subMenu.icon.split('/').pop())} className="invert w-5 inline-block ml-2 " alt={subMenu.caption} />
                                    <span className={`text-sm ${location.pathname.includes(subMenu.title) ? 'text-special1 font-bold' : ''}`}>{localization[subMenu.caption.toLowerCase()]}</span>
                                </div>
                            </div>
                        )
                    })}
            </div>
        </>
    )
}

export default SideBarMenuItem
